import { useQuery } from "@apollo/client"
import { gql } from "../../../../../../../../gql"
import { VariableCompensationSalaryEstimationQueryVariables } from "../../../../../../../../gql/graphql"

const GET_SALARY_ESTIMATION_DATA = gql(`
  query VariableCompensationSalaryEstimation($employmentId: ID!) {
    employment(employmentId: $employmentId) {
      id
      employmentType
      fullTimeHoursPerWeek
      partTimeDaysPerWeek
      partTimeHoursPerDay
      countryCode
      hourlyRate
    }
  }
`)

export const useVarCompSalaryEstimation = (
  variables: VariableCompensationSalaryEstimationQueryVariables,
) => {
  return useQuery(GET_SALARY_ESTIMATION_DATA, { variables, skip: !variables?.employmentId })
}
